import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMaterialForm, sendMaterialOrder, getMaterialOrderHistory } from '../utilities/httpRequest';
import Tag from '../components/Tag';
import TextButton from '../components/TextButton';
import { Send, Eraser } from 'lucide-react';
import AlertWindow from '../components/AlertWindow';
import ImageRoundButton from '../components/ImageRoundButton';
import { ClipboardCopy } from 'lucide-react'

export default function MaterialOrder() {
    const navigate = useNavigate()
    const [materialForm, setMaterialForm] = useState([])
    const [activeMaterialCategory, setActiveMaterialCategory] = useState([])
    const [material, setMaterial] = useState([])
    const [comment, setComment] = useState("")
    const [confirmationWindow, setConfirmationWindow] = useState({
        display: false,
        msg: "",
        links: []
    })

    useEffect(() => {
        async function fetch() {
            const data = await getMaterialForm();
            setMaterialForm(data)
            let materialTmp = []
            data.forEach((category) => {
                materialTmp = materialTmp.concat(category.materials.map((item) => {
                    return {
                        material: item.id,
                        quantity: 0
                    }
                }))
            })
            setMaterial(materialTmp)
        }
        fetch()
    }, [navigate])

    const handleTagClick = (index) => {
        if (activeMaterialCategory.includes(index)) {
            const actualIndex = activeMaterialCategory.indexOf(index);
            setActiveMaterialCategory(activeMaterialCategory.toSpliced(actualIndex, 1))
        } else {
            setActiveMaterialCategory(activeMaterialCategory.concat(index))
        }

    }

    const handleNewForm = () => {
        setMaterial(material.map((mat) => ({
            material: mat.material,
            quantity: 0
        })))
        setComment("")
    }

    const handleValidation = () => {
        if (material.find((item) => item.quantity !== 0)) {

            const OrderRecap = () => {
                return (
                    <div className="text-dark-green">
                        <p className="text-lg mb-1">Récapitulatif de votre demande:</p>
                        <ul className="list-disc ml-5">
                            {material.map((item) => item.quantity !== 0 ? <li className="text-sm" key={item.material}>{getMaterielLabelFromId(item.material, materialForm)}: <span className="font-medium">{item.quantity}</span> unité(s)</li> : null)}
                        </ul>
                        <p className="text-lg mb-1">Commentaire:</p>
                        <p className="text-sm italic">"{comment}"</p>
                    </div>

                )
            }

            setConfirmationWindow({
                display: true,
                object: <OrderRecap />,
                msg: "",
                links: [{
                    href: sendOrder,
                    txt: "Valider"
                }, {
                    href: closeConfirmationWindow,
                    txt: "Retour"
                }]
            })
        } else {
            setConfirmationWindow({
                display: true,
                msg: "Votre commande ne contient aucun matériel.",
                links: [{
                    href: closeConfirmationWindow,
                    txt: "Retour"
                }]
            })
        }
    }

    const sendOrder = async () => {
        //TRIER LES DONNEES
        const body = {
            materials: material.filter((item) => item.quantity !== 0),
            comment: comment
        }
        const loadingElement = document.getElementById("loading");
        if (loadingElement) loadingElement.style.display = "flex";
        try {
            await sendMaterialOrder(navigate, body)
            setConfirmationWindow({
                display: true,
                msg: "Votre commande a été transmise à nos services.",
                links: [{
                    href: () => navigate("/main"),
                    txt: "Retourner à l'accueil"
                }]
            })
        } catch (e) {
            console.error(e.message);
            setConfirmationWindow({
                display: true,
                msg: "Une erreur est survenue.",
                links: [{
                    href: closeConfirmationWindow,
                    txt: "Retour"
                }]
            })
        } finally {
            if (loadingElement) loadingElement.style.display = "none";
        }

    }

    const closeConfirmationWindow = () => {
        setConfirmationWindow({
            display: false,
            msg: "",
            links: [],
            object: null
        })
    }

    return (
        <>
            <AlertWindow display={confirmationWindow.display} msg={confirmationWindow.msg} links={confirmationWindow.links} object={confirmationWindow.object} />
            <div className="flex flex-row flex-wrap h-full p-5 gap-5">
                <div className="flex flex-1 flex-col h-full gap-3">

                    <h1 className="">Commande de matériel</h1>
                    <div className="flex flex-row flex-wrap gap-2">
                        {materialForm.map((category, index) => <Tag key={category.label} label={category.label} active={activeMaterialCategory.includes(index)} onClick={() => handleTagClick(index)} />)}
                    </div>
                    <div>
                        {activeMaterialCategory.map((index) => activeMaterialCategory.includes(index) ? <MaterialBox key={index} form={materialForm[index]} material={material} setMaterial={setMaterial} handleValidation={handleValidation} /> : null)}
                    </div>

                    <div className="flex flex-col gap-2 mt-auto">
                        <div className="labeled-container-div border-light-green mb-2">
                            <p className="labeled-container-p">Commentaire</p>
                            <textarea rows="3" className="w-full outline-none px-1" placeholder="Ajouter un commentaire..." value={comment} onChange={(e) => { setComment(e.target.value) }} />
                        </div>
                        <TextButton text="Soumettre" onClick={handleValidation} lucideIcon={<Send size={16} className="text-medium-green group-hover:text-white" />} />
                        <TextButton text="Recommencer" onClick={handleNewForm} red={true} lucideIcon={<Eraser size={16} className="text-red group-hover:text-white" />} />
                    </div>

                </div>
                <OrderHistory setMaterial={setMaterial} setComment={setComment} materialForm={materialForm}/>
            </div>

        </>
    );
}
function MaterialBox({ form, material, setMaterial, handleValidation }) {
    return (
        <div className="labeled-container-div border-light-green">
            <p className="labeled-container-p">{form.label}</p>
            <div className="grid grid-cols-[repeat(3,max-content)] gap-1">
                {form.materials.map((mat) => <MaterialLine key={mat.id} id={mat.id} label={mat.label} material={material} setMaterial={setMaterial} handleValidation={handleValidation} />)}
            </div>
        </div>
    )
}
const MaterialLine = ({ id, label, material, setMaterial, handleValidation }) => {

    return (
        <>
            <div className="pr-2">{label} :</div>
            <input type="number" className="text-right border border-light-green outline-light-green rounded-md w-16 px-1" value={getMaterialQty(material, id)} onChange={(e) => setMaterialQty(setMaterial, id, e.target.value)} onKeyDown={(event) => event.key === "Enter" ? handleValidation() : null} />
            <p>unité(s)</p>
        </>
    )
}
function setMaterialQty(setMaterial, id, newQty) {
    let qty = (newQty && newQty > 0) ? Number.parseInt(newQty) : 0;
    qty = qty > 999 ? 1000 : qty
    setMaterial((old) => {
        return old.map((material) => {
            if (material.material === id) {
                return {
                    material: id,
                    quantity: qty
                }
            } else {
                return material
            }
        })
    })
}
function getMaterialQty(material, id) {
    return material.find((item) => item.material === id)?.quantity
}
function getMaterielLabelFromId(id, materialForm) {
    for (const category of materialForm) {
        for (const material of category.materials) {
            if (material.id === id) {
                return material.label;
            }
        }
    }
    return null; // ou undefined si tu préfères
}
function OrderHistory({setMaterial,setComment,materialForm}) {

    const navigate = useNavigate()

    const [history, setHistory] = useState([])

    useEffect(() => {
        async function fetch() {
            const data = await getMaterialOrderHistory();
            setHistory(data)
        }
        fetch()
    }, [navigate])

    const initialWindow = {
        display: false,
        msg: "",
        links: []
    }
    const [confirmationWindow, setConfirmationWindow] = useState(initialWindow)

    const FillRow = ({ order }) => {
        return (
            <tr className="bg-white cursor-pointer hover:bg-light-gray odd:bg-clear-green">
                <td className="text-center px-3 font-medium" onClick={() => openDetails(order)}>{order.id}</td>
                <td className="text-center px-3 italic" onClick={() => openDetails(order)}>{order.date}</td>
                <td className="text-center px-3" onClick={() => openDetails(order)}><p className="m-auto font-medium text-sm py-1 px-2 ring-2 rounded-full ring-light-green">{order.status}</p></td>
                <td className="px-3 py-1 text-center">
                    <ImageRoundButton className="size-8 mx-auto" color="bg-medium-green" onClick={() => copy(order)} title="Recopier la commande" lucide={<ClipboardCopy size={20} strokeWidth={2} color="white" />} />
                </td>
            </tr>
        );
    }

    const OrderRecap = ({order}) => {
        return (
            <div className="text-dark-green">
                <p className="text-lg mb-1">Date:</p>
                <p className="text-sm italic">{order.date}</p>
                <p className="text-lg mb-1">Statut du traitement:</p>
                <p className="text-sm italic">{order.status}</p>
                <p className="text-lg mb-1">Matériel commandé:</p>
                <ul className="list-disc ml-5">
                    {order.materials.map((item) => item.quantity!==0?<li className="text-sm" key={item.material+" "+order.id}>{getMaterielLabelFromId(item.material, materialForm)}: <span className="font-medium">{item.quantity}</span> unité(s)</li>:null)}
                </ul>
                <p className="text-lg mb-1">Commentaire:</p>
                <p className="text-sm italic">"{order.comment}"</p>
            </div>

        )
    }

    const openDetails = (order) => {
        setConfirmationWindow({
            display: true,
            object: <OrderRecap order={order} />,
            msg: "",
            links: [{
                href: ()=>{copy(order);setConfirmationWindow(initialWindow)},
                txt: "Recopier"
            }, {
                href: ()=>setConfirmationWindow(initialWindow),
                txt: "Retour"
            }]
        })
    }

    const copy = (order) => {
        setComment(order.comment)
        setMaterial(order.materials)
    }




    return (
        <>
            <AlertWindow display={confirmationWindow.display} msg={confirmationWindow.msg} links={confirmationWindow.links} object={confirmationWindow.object} />
            <div className="h-full bg-medium-green max-h-full pb-5 pt-3 overflow-hidden flex flex-col shadow-sym rounded-2xl">
                <div className="flex justify-between">
                    <h1 className="text-white px-5 pb-3">Historique</h1>
                </div>
                <div className="h-full overflow-y-auto">
                    <table className="w-full text-dark-green border-collapse">
                        <thead>
                            <tr className="bg-light-green text-white h-10">
                                <th className="font-medium text-center px-3">N°</th>
                                <th className="font-medium text-center px-3">Date</th>
                                <th className="font-medium text-center px-3">Statut</th>
                                <th className="font-medium text-center px-3">Copier</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((order) => <FillRow key={order.id} order={order} />)}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}